import { AppSettings } from "./types";

export const DEFAULT_SETTINGS: AppSettings = {
  cm: {
    feHost: "cmfe-lite.lstdev.net",
    beHost: "cm-lite.lstdev.net",
    regHost: "lite.lstdev.net",
  },
};
